import React from 'react';
import { Flex, Popover, Space, Tag, Typography } from 'antd';

const { Text } = Typography;


const RenderChips = ({ chips, cutOff = 3 }) => {
  const visibleChips = chips.slice(0, cutOff);
  const hiddenChips = chips.slice(cutOff);

  return (
    <div className="render-tags">
      <Flex align="center" gap={8}>
        <Space wrap>
          {visibleChips}
          {hiddenChips.length > 0 && (
            <Popover
              content={
                <div style={{ maxWidth: 400, overflow: 'auto' }}>
                  <Space wrap>{hiddenChips}</Space>
                </div>
              }
              placement="bottomRight"
              trigger="hover"
            >
              <Tag className="pointer" color="processing">{`+${hiddenChips.length}`}</Tag>
            </Popover>
          )}
        </Space>
      </Flex>
    </div>
  );
};

export default RenderChips;